import React from 'react';
import {
  AppBar,
  Toolbar,
  Typography,
  Box,
  Container,
  Button,
} from '@mui/material';
import { Link, useLocation } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';

const Header = () => {
  const location = useLocation();
  const { lang, t, toggleLang } = useLanguage();

  return (
    <AppBar 
      position="static" 
      elevation={0}
      sx={{ 
        bgcolor: 'background.default',
        borderBottom: '1px solid rgba(0,0,0,0.08)',
      }}
    >
      <Container maxWidth="lg">
        <Toolbar sx={{ justifyContent: 'space-between', py: 1 }}>
          <Box 
            component={Link} 
            to="/" 
            aria-label="Biblitz Home"
            sx={{ 
              display: 'flex', 
              alignItems: 'center', 
              gap: 1.5,
              textDecoration: 'none',
              color: 'inherit'
            }}
          >
            <Box
              component="img"
              src="/assets/biblitz_logo.png"
              alt="Biblitz"
              sx={{ width: 36, height: 36, borderRadius: '20%' }}
            />
            <Typography 
              variant="h4" 
              component="span"
              sx={{ 
                fontWeight: 700,
                color: 'primary.main',
                letterSpacing: '-0.02em'
              }}
            >
              Biblitz
            </Typography>
          </Box>
          
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            {/* Language Toggle */}
            <Button
              onClick={toggleLang}
              variant="outlined"
              size="small"
              sx={{
                borderColor: 'secondary.main',
                color: 'primary.main',
                fontWeight: 700,
                fontSize: '0.8rem',
                minWidth: 64,
                borderRadius: 2,
                '&:hover': {
                  bgcolor: 'secondary.light',
                  borderColor: 'secondary.dark',
                },
              }}
            >
              {lang === 'en' ? '中文' : 'EN'}
            </Button>

            {location.pathname !== '/privacy' && (
              <Button
                component={Link}
                to="/privacy"
                color="inherit"
                sx={{ color: 'text.secondary' }}
              >
                {t.privacy}
              </Button>
            )}
          </Box>
        </Toolbar>
      </Container>
    </AppBar>
  );
};

export default Header;
